<ng-container [formGroup]="formGroup">
  <i class="fas fa-eye mu-custom-icon-password" (click)="utils.changeInputTypePassword($event, field)" aria-hidden="true"></i>
  <input
    autocomplete="new-password"
    type="password"
    [name]="field"
    [id]="field"
    [formControlName]="field"
    [placeholder]="'form.placeholder.' + field | translate"
  />
  <app-mu-form-password-checker
    *ngIf="checkPassword && formGroup && formGroup.get(field).value"
    [formGroup]="formGroup"
    [passwordCheckerName]="passwordCheckerName"
    [passwordCheckerField]="passwordCheckerField"
    [passwordCheckerParams]="passwordCheckerParams"
  ></app-mu-form-password-checker>
</ng-container>
